import { axios, AxiosResponse } from "@sdk/axios";
import type {
  CrmCreationSummaryRequest,
  CrmCreationSummaryResponse,
} from "./crm-reports.models";

export async function fetchCrmCreationSummary(
  config: { basePath: string; token: string },
  req: CrmCreationSummaryRequest
): Promise<CrmCreationSummaryResponse> {
  const results: AxiosResponse<CrmCreationSummaryResponse> = await axios.post(
    `${config.basePath}/crm/reports/creation-summary`,
    req,
    { headers: { Authorization: config.token } }
  );
  return results.data;
}
